import { ILgpHeroSticky } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidLgpHeroSticky } from './typeguards';
import { LgpHeroStickySubscription } from '../types';
import { ErrorName, WidgetError } from '../../../utils/errors';
import { RaceSessionStatus, RaceSessionType } from '../../../types/lgp';
import { LgpHeroStickyInfo, LgpHeroStickySession } from 'appsync';

export default (obj: LgpHeroStickySubscription): ILgpHeroSticky => {
  if (isValidLgpHeroSticky(obj)) {
    const { info, session } = obj?.data.onUpdateLgpHeroStickyBySeasonAndCompIdAndGpId;
    const { flagImgUrl, customGpName, startDate, endDate } = info as LgpHeroStickyInfo;
    const { label, status } = session as LgpHeroStickySession;

    return {
      flagImgUrl: flagImgUrl as string,
      customGpName: customGpName as string,
      startDate: startDate as string,
      endDate: endDate as string,
      sessionStatus: status as RaceSessionStatus,
      sessionName: label as RaceSessionType,
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LgpHeroStickySubscription object',
      data: obj
    });
  }
};
